import React from "react";
import { useLocation } from "react-router-dom";
import "./navItem.scss";

const NavItem = (props) => {
  const { label, Icon, CustomIcon, to,onClick, enabled } = props.item;
  const location = useLocation();
  const instaCollectPath = "insta-collect";
  const renderIconAndLabel = () => {
    return (
      <>
        <img className="navIcon" src={Icon} alt="" />
        <span className="navLabel">{label}</span>
        <span className="navItem-tooltip">{label}</span>
      </>
    )
  }

  return (
    <>
      {
        (to && to.length != 0 ? (
          <a
            href={to}
            className={`navItem ${!location.pathname.includes(instaCollectPath) && label == "Wire"
              ? `activeNavItem`
              : location.pathname.includes(instaCollectPath) &&
                label == "InstaCollect"
                ? `activeNavItem`
                : null
              }  ${!enabled ? `disabled` : null}`}
            target={`${label == "Wire" ? `_self` : `_blank`}`}
          >
            {renderIconAndLabel()}
          </a>
        ) : (
          <span className={`navItem ${!enabled ? `disabled` : null}`}>
            {renderIconAndLabel()}
          </span>

        ))
      }
    </>
  );
};

export default NavItem;
